module.exports = __webpack_public_path__ + "navSample.4d33fd201bdf08f6ac1fbf097dfbfaff.png";